// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__owKgq","title":"Header_title__1-GG5","left":"Header_left__2QfER","clinicName":"Header_clinicName__1pAeM"};